/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { DisclosurePhysicianRequest } from "../interview/types/DisclosurePhysicianRequest";
import { Doctor } from "./types/Doctor";
import { PhysicianResource } from "./types/PhysicianResource";
import { PrimaryPhysicianRequest } from ".//types/PrimaryPhysicianRequest";
import { mapDoctorToPhysicianResource } from "./utils";

interface PhysicianState {
  error: string | undefined;
  loading: boolean;
  search: {
    results: Doctor[];
    loading: boolean;
    error: string | undefined;
  };
  selected: PhysicianResource | undefined;
}

const initialState: PhysicianState = {
  error: undefined,
  loading: false,
  search: {
    error: undefined,
    loading: false,
    results: [],
  },
  selected: undefined,
};

export const PHYSICIAN_SEARCH_RESULT_LIMIT = 10;

const physicianSlice = createSlice({
  name: "physician",
  initialState,
  reducers: {
    requestPhysicianInformation: (state, action: PayloadAction<string>) => {
      state.search.loading = true;
      state.search.error = undefined;
      state.search.results = [];
    },
    requestPhysicianInformationSuccessful: (
      state,
      action: PayloadAction<typeof initialState.search.results>,
    ) => {
      state.search.results = action.payload.slice(
        0,
        PHYSICIAN_SEARCH_RESULT_LIMIT,
      );
      state.search.loading = false;
    },
    requestPhysicianInformationFailed: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.search.loading = false;
      state.search.error = action.payload;
    },
    clearPhysicianInformationResults: (state) => {
      state.search.results = [];
    },
    setCustomerPhysician: (state, action: PayloadAction<Doctor>) => {
      state.selected = mapDoctorToPhysicianResource(action.payload);
    },
    setUserDefinedPhysician: (
      state,
      action: PayloadAction<PhysicianResource>,
    ) => {
      state.selected = action.payload;
    },
    unsetCustomerPhysician: (state) => {
      state.selected = undefined;
    },
    requestCreatePrimaryPhysician: (
      state,
      action: PayloadAction<PrimaryPhysicianRequest>,
    ) => {
      state.loading = true;
      state.error = undefined;
    },
    requestCreatePrimaryPhysicianSuccessful: (
      state,
      action: PayloadAction<PhysicianResource>,
    ) => {
      state.loading = false;
    },
    requestCreatePrimaryPhysicianFailed: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.loading = false;
      state.error = action.payload.toString();
    },
    requestUpdatePrimaryPhysician: (
      state,
      action: PayloadAction<PrimaryPhysicianRequest>,
    ) => {
      state.loading = true;
      state.error = undefined;
    },
    requestUpdatePrimaryPhysicianSuccessful: (
      state,
      action: PayloadAction<PhysicianResource>,
    ) => {
      state.loading = false;
    },
    requestUpdatePrimaryPhysicianFailed: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.loading = false;
      state.error = action.payload.toString();
    },
    requestDeletePrimaryPhysician: (
      state,
      action: PayloadAction<{ caseId: string }>,
    ) => {
      // Not implemented.
    },
    requestDeletePrimaryPhysicianSuccessful: (
      state,
      action: PayloadAction<string>,
    ) => {
      // Not implemented.
    },
    requestDeletePrimaryPhysicianFailed: (
      state,
      action: PayloadAction<string>,
    ) => {
      // Not implemented.
    },
    requestCreateDisclosurePhysician: (
      state,
      action: PayloadAction<DisclosurePhysicianRequest>,
    ) => {
      state.loading = true;
    },
    requestCreateDisclosurePhysicianSuccessful: (
      state,
      action: PayloadAction<any>,
    ) => {
      state.loading = false;
    },
    requestCreateDisclosurePhysicianFailed: (state) => {
      state.loading = false;
    },
    requestUpdateDisclosurePhysician: (
      state,
      action: PayloadAction<DisclosurePhysicianRequest>,
    ) => {
      state.loading = true;
    },
    requestUpdateDisclosurePhysicianSuccessful: (
      state,
      action: PayloadAction<DisclosurePhysicianRequest>,
    ) => {
      state.loading = false;
    },
    requestUpdateDisclosurePhysicianFailed: (state) => {
      state.loading = false;
    },
  },
});

export const { actions } = physicianSlice;
export default physicianSlice.reducer;
export const {
  clearPhysicianInformationResults,
  requestCreateDisclosurePhysician,
  requestCreatePrimaryPhysician,
  requestUpdatePrimaryPhysician,
  requestPhysicianInformation,
} = actions;
export { initialState };
